export const detailedQualifiedListTourSteps = [
  {
    element: '.offcanvas-body',
    popover: {
      title: 'Editar Contato Qualificado - Visão Geral',
      description: 'Bem-vindo à tela de edição de contato qualificado! Aqui você pode atualizar informações do contato, alterar o status, definir agendamentos, visualizar e adicionar mensagens. Vamos explorar cada funcionalidade em detalhes.',
      side: 'top' as const,
      align: 'center' as const
    }
  },
  {
    element: '#tour-modal-informacoes-cliente',
    popover: {
      title: 'Informações do Cliente',
      description: 'Aqui você visualiza todas as informações do cliente, como nome, CNPJ, contato, email, telefone e celular. Clique no cabeçalho para expandir ou recolher esta seção.',
      side: 'right' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-modal-status',
    popover: {
      title: 'Status do Contato',
      description: 'Selecione o status atual do contato qualificado. O status determina em qual etapa do processo de qualificação o contato se encontra. Você pode alterar o status conforme o contato avança no processo.',
      side: 'right' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-modal-agendamento',
    popover: {
      title: 'Agendamento',
      description: 'Defina a data e hora do próximo contato com este cliente. Este campo ajuda a organizar o acompanhamento dos contatos qualificados e permite que você agende futuras interações.',
      side: 'right' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-modal-mensagens',
    popover: {
      title: 'Histórico de Mensagens',
      description: 'Aqui você visualiza todas as mensagens já cadastradas para este contato, incluindo a data de cadastro de cada uma. Este histórico permite acompanhar todas as interações anteriores com o cliente.',
      side: 'right' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-modal-mensagem-personalizada',
    popover: {
      title: 'Mensagens Personalizadas',
      description: 'Selecione uma mensagem pré-cadastrada do sistema. Ao selecionar, o texto será automaticamente preenchido no campo "Nova Mensagem", facilitando o uso de mensagens padrão.',
      side: 'right' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-modal-nova-mensagem',
    popover: {
      title: 'Nova Mensagem',
      description: 'Digite uma nova mensagem para este contato. Você pode usar uma mensagem personalizada selecionada acima ou escrever uma mensagem completamente personalizada. Este campo é obrigatório ao salvar.',
      side: 'right' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-modal-salvar',
    popover: {
      title: 'Salvar Alterações',
      description: 'Use este botão para salvar todas as alterações feitas no contato, incluindo status, agendamento e nova mensagem. Certifique-se de preencher a mensagem antes de salvar, pois este campo é obrigatório.',
      side: 'top' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-modal-novo-projeto',
    popover: {
      title: 'Novo Projeto',
      description: 'Clique neste botão para criar um novo projeto relacionado a este cliente. Ao clicar, será aberta uma modal para adicionar um novo projeto, com as informações do cliente já pré-preenchidas.',
      side: 'top' as const,
      align: 'end' as const
    }
  }
];

